import * as types from '@/store/types'
export default {
    postCreate(context, payload) {
        context.posts.push(payload)
    },
    postAll(context, payload) {
        payload.forEach((item, i) => {
            if (!item.other_params.hasOwnProperty('changeGlobalVariables')) {
                payload[i].other_params.changeGlobalVariables = { variablesIds: [], function: '' }
            }
        })
        context.posts = payload
    },
    postUpdate: (context, payload) => {
        const index = context.posts.findIndex(item => item.id === payload.id)
        context.posts[index] = payload
    },
    changeBotIdModelDefault: (context, botId) => {
        context.modelDefault.bot_id = botId
    }
}
